import React, { lazy } from 'react';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { getLogsInfoDisplay, hasValue } from 'globalutils/fmUtils';
import { generateColumns, generateRows, getEmptyMessage } from './utils/tableHelpers';
const layout = window?.$environment?.CURRENT_LAYOUT;

const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Component {...contentProps} />
    </Box>
  );
};

const Component = ({ i18n, logsHistory, apiStatus, apiId, Styled, viewReport }) => {
  const rows = generateRows(logsHistory, viewReport);
  const columns = generateColumns(i18n);
  const emptyMessage = getEmptyMessage(apiStatus, apiId, i18n);

  return (
    <Styled.Wrapper>
      {layout !== 'SpireonNew' && (
        <Label className="logsInfoDisplay">
          {getLogsInfoDisplay(i18n, logsHistory?.driverName, logsHistory?.day)}
        </Label>
      )}
      <div className="tableWrapper">
        <Table
          type="client"
          defaultSortBy={{ sortBy: 'version', order: 'desc' }}
          title=""
          columns={columns}
          emptyMessage={emptyMessage}
          data={rows}
          itemsPerPage={window?.$environment?.SERVICE_PROVIDER === 'spireon' ? 10 : 15}
          actions={[]}
          i18n={i18n}
        />
      </div>
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  apiStatus: PropTypes.object.isRequired,
  logsHistory: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  apiId: PropTypes.string.isRequired,
  Styled: PropTypes.object.isRequired,
  viewReport: PropTypes.func.isRequired
};

export default Index;
